export class loginClass{
    constructor(
        public id_empresa: string,
        public user: string,
        public pass:string
    ){}
}